module.exports = __WEBPACK_EXTERNAL_MODULE_openfl_media_SoundTransform__;